import * as React from 'react';
import {styled} from '@mui/material/styles';
import Badge from '@mui/material/Badge';
import Avatar from '@mui/material/Avatar';
import Stack from '@mui/material/Stack';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Divider from '@mui/material/Divider';
import PropTypes from "prop-types";
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import {useNavigate} from 'react-router-dom';
import SoftTypography from "../../../components/SoftTypography";
import { useTranslation } from "react-i18next";

const UserAvatar = (props) => {
    const {username, handleLogout, picture} = props;


    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const navigate = useNavigate();
    const { t, i18n } = useTranslation('common');
    const currentLanguage = i18n.language;


    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };


    const handleProfile = () => {
        handleClose();
        navigate(`/${currentLanguage}/profile`);
    };


    const logout = () => {
        handleLogout();
        handleClose();
    };

    const StyledBadge = styled(Badge)(({theme}) => ({
        '& .MuiBadge-badge': {
            backgroundColor: '#44b700',
            color: '#44b700',
            boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
            '&::after': {
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                borderRadius: '50%',
                animation: 'ripple 1.2s infinite ease-in-out',
                border: '1px solid currentColor',
                content: '""',
            },
        },
        '@keyframes ripple': {
            '0%': {
                transform: 'scale(.8)',
                opacity: 1,
            },
            '100%': {
                transform: 'scale(2.4)',
                opacity: 0,
            },
        },
    }));

    return (
        <Stack direction="row" spacing={2}>
            <IconButton
                onClick={handleClick}
                size="small"
                sx={{ml: 2}}
                aria-controls={open ? 'account-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
            >
                {StyledBadge && (
                    <StyledBadge
                        overlap="circular"
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                        variant="dot"
                    >
                        <Avatar
                            alt={username || "User"}
                            src={picture || ""}
                            sx={{ width: 35, height: 35 }}
                        />
                    </StyledBadge>
                )}
                {username && (
                    <SoftTypography variant="h6" fontWeight="bold">
                        {username}
                    </SoftTypography>
                )}
            </IconButton>
            <Menu
                anchorEl={anchorEl}
                id="account-menu"
                open={open}
                onClose={handleClose}
                PaperProps={{
                    elevation: 0,
                    sx: {
                        overflow: 'visible',
                        filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                        mt: 1.5,
                        '& .MuiAvatar-root': {
                            width: 32,
                            height: 32,
                            ml: -0.5,
                            mr: 1,
                        },
                        '&:before': {
                            content: '""',
                            display: 'block',
                            position: 'absolute',
                            top: 0,
                            right: 14,
                            width: 10,
                            height: 10,
                            bgcolor: 'background.paper',
                            transform: 'translateY(-50%) rotate(45deg)',
                            zIndex: 0,
                        },
                    },
                }}
                transformOrigin={{horizontal: 'right', vertical: 'top'}}
                anchorOrigin={{horizontal: 'right', vertical: 'bottom'}}
            >
                <MenuItem onClick={handleProfile}>
                    <AccountCircleIcon fontSize="small" sx={{marginRight: 1, marginLeft: 1}}/>
                    {t('navbar.myProfile')}
                </MenuItem>
                <Divider/>
                <MenuItem onClick={logout}>
                    <PowerSettingsNewIcon fontSize="small" sx={{color: 'red', marginRight: 1, marginLeft: 1}}/>
                    <span style={{color: 'red'}}>{t('navbar.signOut')}</span>
                </MenuItem>
            </Menu>

        </Stack>
    );
};

// Typechecking props for the UserAvatar
UserAvatar.propTypes = {
    username: PropTypes.string,
    handleLogout: PropTypes.func.isRequired,
    picture: PropTypes.string,
};

export default UserAvatar;
